import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApiClient } from '@chilipiper/api-client/src/context'
import { defaultErrorCallback } from '@chilipiper/service/src/api'
import { ApiError } from '@chilipiper/service/src/types'
import { PublicTenantDetail } from '@chilipiper/api-client/src/workspace'

const getWorkspaceTenantDetailsKey = (tenantId: string) => ['workspace-tenant-details', tenantId]
export const useTenantDetails = (tenantId: string) => {
  const { workspace } = useApiClient()

  return useQuery({
    queryKey: getWorkspaceTenantDetailsKey(tenantId),
    queryFn: () => workspace.tenantDetailGetGuest(tenantId),
  })
}
export const useUpdateTenantDetails = (tenantId: string) => {
  const { workspace } = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: { name: string }) => workspace.postApiV1TenantTenantid(tenantId, payload),
    onError: error => defaultErrorCallback(error as unknown as ApiError),
    onMutate: async ({ name }) => {
      await queryClient.cancelQueries({ queryKey: getWorkspaceTenantDetailsKey(tenantId) })
      queryClient.setQueryData<PublicTenantDetail>(
        getWorkspaceTenantDetailsKey(tenantId),
        previousData => {
          if (!previousData) {
            return { name }
          }
          return { ...previousData, name }
        }
      )
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: getWorkspaceTenantDetailsKey(tenantId) }),
  })
}
